/**
 * Which offer is this website page selling? ONE answer, for every caller that
 * tells Brill.
 *
 * Two places can say it: the page's own cog ("Offer it serves", 0015) and the
 * SITE's cog ("Offer it serves", also 0015). Until 2026-09-24 only the page's
 * reached Brill — and only from the drafting chat; the sparkle sent no offer at
 * all. Her report: a landing site made for the Archetype Assessment, linked to
 * it at the SITE, got a banner about her eight-week flagship, because nothing
 * told Brill which offer the page was for, so it wrote from her Accelerator
 * Signature Offer.
 *
 * THE PAGE WINS, then the site. A homepage and a sales page can live on one
 * site and sell different things, so the narrower answer is the truer one when
 * she has given it. Most pages will never have their own — the site is where
 * she links it, and where the cog warns when she has not.
 *
 * NOT an answer: an offer's "Where it sends people" pointing at this page.
 * That says where the offer sends traffic, and a homepage receives traffic for
 * several offers at once. Treating it as "this page sells that offer" would
 * pick one of them at random.
 */
export function offerForPage(page, sites = [], offers = []) {
  const byId = (id) => (id && (offers || []).find((o) => o.id === id)) || null;
  const site = (sites || []).find((s) => s.id === page?.siteId);
  return byId(page?.offerId) || byId(site?.offerId);
}
